import { createActions } from 'redux-actions';

export const {
  businessModule: { getId, receiveId, receiveName },
}: any = createActions({
  BUSINESS_MODULE: {
    GET_ID: () => ({
      isFetchingId: true,
    }),
    RECEIVE_ID: (id) => ({
      isFetchingId: false,
      id,
    }),
    RECEIVE_NAME: (name) => ({
      name,
    }),
  },
});
